<template>
  <div>
    <NavigationBar titel="Dokumentvorlagen" :actions="actions"></NavigationBar>
    <section>
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-data-iterator
                :items="filteredTemplates"
                :search="search"
                disable-pagination
                hide-default-footer
                no-data-text="Keine Dokumentvorlagen vorhanden"
                no-results-text="Keine Dokumentvorlagen zum Suchbegriff gefunden."
              >
                <template v-slot:header>
                  <v-row>
                    <v-col>
                      <v-card class="mb-2">
                        <v-card-title>
                          <v-text-field
                            v-model="search"
                            outlined
                            label="Nach Vorlage suchen"
                            dense
                            prepend-inner-icon="mdi-magnify"
                            clearable
                            hide-details
                          ></v-text-field>
                        </v-card-title>
                        <v-card-text>
                          <v-chip-group
                            v-model="selectedCategory"
                            active-class="primary--text"
                          >
                            <v-chip
                              v-for="category in categoryTypeOptions"
                              :key="category.value"
                              :value="category.value"
                              filter
                              outlined
                            >
                              <v-icon left small>{{ category.icon }}</v-icon>
                              {{ category.text }}
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="template in props.items"
                      :key="template.meta.id"
                      cols="12"
                      md="6"
                      lg="4"
                    >
                      <v-card hover @click="openDetails(template.meta.id)">
                        <v-card-title>
                          {{ template.name }}
                        </v-card-title>
                        <v-card-subtitle>
                          <v-chip small class="mr-2" outlined>
                            <v-icon left small>{{
                              template.category && template.category.icon
                                ? template.category.icon
                                : "mdi-shape"
                            }}</v-icon>
                            {{
                              template.category
                                ? template.category.title
                                : "Keine"
                            }}
                          </v-chip>
                          <v-chip small outlined>
                            <v-icon left small>mdi-database</v-icon>
                            {{ getContextLabel(template.placeholderContext) }}
                          </v-chip>
                        </v-card-subtitle>
                        <v-card-text v-if="template.description">
                          {{ template.description }}
                        </v-card-text>
                        <v-card-text
                          v-if="
                            template.activeVersion &&
                            template.activeVersion.fileName
                          "
                        >
                          <v-icon small class="mr-1">mdi-file-word</v-icon>
                          {{ template.activeVersion.fileName }}
                          <v-chip x-small class="ml-2" outlined>
                            v{{ template.activeVersion.versionNumber }}
                          </v-chip>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import { MY_ORGANIZATION } from "@/store/modules.js";
import { GET_DOCUMENT_TEMPLATES } from "@/store/action-types.js";
import { MY_ORGANIZATION_DOCUMENT_TEMPLATES_create } from "@/data/permission-types.js";
import { PLACEHOLDER_CONTEXTS } from "@/util/documentTemplateService.js";

export default {
  name: "processes-document-templates",
  components: {
    NavigationBar,
  },
  data() {
    return {
      search: "",
      selectedCategory: null,
      actions: [
        {
          title: "Erstellen",
          permission: `${MY_ORGANIZATION_DOCUMENT_TEMPLATES_create}`,
          icon: "mdi-plus-circle",
          actionStyle: "textBtn",
          function: this.createTemplate,
        },
      ],
      categoryTypeOptions: [
        { text: "Alle", value: null, icon: "mdi-view-grid" },
        {
          text: "Funktionen",
          value: "assignment",
          icon: "mdi-account-hard-hat",
        },
        { text: "Einheiten", value: "unit", icon: "mdi-fire-truck" },
        { text: "Abteilungen", value: "division", icon: "mdi-domain" },
        { text: "Sonstige", value: "other", icon: "mdi-dots-horizontal" },
      ],
    };
  },
  computed: {
    documentTemplates() {
      return this.$store.state.myOrganization.documentTemplates;
    },
    filteredTemplates() {
      if (!this.selectedCategory) return this.documentTemplates;
      return this.documentTemplates.filter(
        (t) => t.category && t.category.type === this.selectedCategory,
      );
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${MY_ORGANIZATION}${GET_DOCUMENT_TEMPLATES}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
    createTemplate() {
      this.$router.push({
        name: "processes-document-templates-new",
        params: {
          organizationId: this.$route.params.organizationId,
        },
      });
    },
    openDetails(templateId) {
      this.$router.push({
        name: "processes-document-templates-details",
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: templateId,
        },
      });
    },
    getContextLabel(context) {
      const config = PLACEHOLDER_CONTEXTS[context];
      return config ? config.label : context;
    },
  },
};
</script>
